import { useState } from "react";
import { Table, Space, Button, message,Modal } from "antd";
import SemesterService from "../../../services/SemesterService";
import SemesterModalForm from './SemesterModalForm';
const getColumns = (setSemesterTarget,showModalForm,showModalDelete) => {
  return [
    {
      title: "Semestre",
      dataIndex: "semester",
      key: "semester",
      width: "100px",
      render: (text, record) => <span>{record.name}</span>,
      fixed: "left",
    },
    {
      title: "Año",
      dataIndex: "year",
      width: "150px",
      key: "year",
      render: (text, record) => <span>{record.year}</span>,
    },
    {
      title: "Acciones",
      key: "action",
      width: "150px",
      render: (text, record) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => {
              setSemesterTarget(record);
              showModalForm();
            }}
          >
            Editar
          </Button>
          <Button
            type="link"
            onClick={() => {
              setSemesterTarget(record);
              showModalDelete();
            }}
          >
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];
};
export default function Semester({ list = [], getData, setSemesters }) {
  const [semesterTarget, setSemesterTarget] = useState(null);
  const [isModalFormVisible, setIsModalFormVisible] = useState(false);
  const [isModalDeleteVisible, setIsModalDeleteVisible] = useState(false);

  const showModalDelete = () => {
    setIsModalDeleteVisible(true);
  };
  const handleOkDelete = () => {
    SemesterService.deleteSemester(semesterTarget)
      .then((res) => {
        if (res.data?.success) {
          message.success("Semestre eliminado.", 3);
          getData()
            .then((res) => {
              handleCancelDelete();
              setSemesters(res);
            })
            .catch((e) => {
              console.log("error", e.message);
              message.error("No se pudo obtener la lista de semestres.", 5);
            });
        } else {
          message.error(
            "No se pudo eliminar la semestres. " + res.data?.description,
            5
          );
        }
      })
      .catch((e) => {
        console.log("error.", e.message);
        message.error("Hubo un error. " + e.message, 5);
      });
  };

  const handleCancelDelete = () => {
    setSemesterTarget(null);
    setIsModalDeleteVisible(false);
  };

  const showModalForm = () => {
    setIsModalFormVisible(true);
  };
  const handleOkForm = () => {
    getData()
      .then((res) => {
        setSemesterTarget(null);
        setIsModalFormVisible(false);
        setSemesters(res);
      })
      .catch((e) => {
        console.log("error", e.message);
        message.error("No se pudo obtener la lista de carreras.", 5);
      });
  };

  const handleCancelForm = () => {
    setSemesterTarget(null);
    setIsModalFormVisible(false);
  };
  return (
    <>
      <Button
        type="primary"
        onClick={() => {
          showModalForm();
        }}
        style={{ marginBottom: "1em" }}
      >
        +Registrar nuevo Semestre
      </Button>
      <Table
        columns={getColumns(setSemesterTarget,showModalForm,showModalDelete)}
        dataSource={list}
        rowKey="id"
        scroll={{ x: "max-content" }}
      />
      {isModalFormVisible ? (
        <SemesterModalForm
          isModalVisible={isModalFormVisible}
          handleOk={handleOkForm}
          handleCancel={handleCancelForm}
          semesterTarget={semesterTarget}
        />
      ) : null}
      {isModalDeleteVisible ? (
        <Modal
          visible={isModalDeleteVisible}
          title="Eliminar Semestre"
          onOk={handleOkDelete}
          onCancel={handleCancelDelete}
          okText="Aceptar"
          cancelText="Cancelar"
        >
          <p>
            ¿Desea eliminar el semestre{" "}
            <strong>
              {semesterTarget?.name + " - " + semesterTarget?.year}
            </strong>
            ?
          </p>
        </Modal>
      ) : null}
    </>
  );
}
